import {
  
  ErrorHandler,
  ModuleWithProviders,
  NgModule,
} from "@angular/core";

import {
  AgentInfoService,
  AuthenticationService,
  AuthorizationService,
  BrowserGlobalService,
  DeactivateGuardService,
  LoaderManagerService,
  LocalResourcesManagerService,
  LoginService,
  LogoutBehaviorService,
  LogoutService,
  PaymentService,
  PipeLineErrorService,
  PreconnectService,
  QuestionsService,
  SerializationHelperService,
  SharedService,
  ThemeService,
  UserPreferenceService,
  UserService,
  adpAPIService
} from "../services";
import { ConfigService } from "../services/config.service";
import { DeviceService } from "../services/device.service";
import { DocumentsService } from "../services/documents.service";
import { ErrorLogService } from "../services/error-handling/error-log.service";
import { GlobalErrorHandler } from "../services/error-handling/global-error-handler";
import { HeaderFactoryService } from "../services/header-factory.service";
import { SalesApplicationService } from "../services/sales-application.service";
import { ShareDataService } from "../services/share-data.service";
import { TokenService } from "../services/token.service";

import { AppInsightsLoggingService } from "common/services/logging/app-insights-service";
import { MessageDisplayLoaderService } from "common/services/message-display-loader-service";
import { TerashopService } from "common/services/terashop-service";
import {
  AppLoadService,
  ENV,
  EncriptionService,
  NotificationService,
  ProgressLoaderAssurantService,
  ProgressLoaderService,
  RegisterCustomIconService,
  ADPResourceService as ResourceService,
  ResourcesLoaderService,
} from "digital-core";
import { BrowserValidatorService } from "../services/browser-validator.service";
import { CurrencyService } from "../services/currency.service";
import { DateTimeService } from "../services/date-time.service";
import { DocumentLoaderService } from "../services/document-loader.service";
import { GlobalEventService } from "../services/global-event.service";
import { GoogleAnalyticsService } from "../services/google-analytics.service";
import { FileUploadService } from "../services/helpers/file-upload/file-upload.service";
import { HtmlHelpersService } from "../services/helpers/html-helpers.service";
import { PolicyService } from "../services/policy.service";
import { ProfileService } from "../services/profile.service";
import { SalesService } from "../services/sales.service";
import { ViewerService } from "../services/viewer.service";
import { NavigationService } from "common/services/navigation.service";
import { SeoService } from "common/services/seo.service";

@NgModule({
  providers: [
    TokenService,
    SalesService,
    ResourceService,
    ResourcesLoaderService,
    ProgressLoaderAssurantService,
    ProfileService,
    ProgressLoaderService,
    PolicyService,
    PaymentService,
    LoginService,
    LogoutBehaviorService,
    LogoutService,
    ErrorLogService,
    AuthenticationService,
    AuthorizationService,
    BrowserGlobalService,
    CurrencyService,
    DeactivateGuardService,
    HeaderFactoryService,
    TokenService,
    DeviceService,
    DocumentsService,
    ThemeService,
    EncriptionService,
    FileUploadService,
    GoogleAnalyticsService,
    HtmlHelpersService,
    LoaderManagerService,
    DateTimeService,
    NotificationService,
    SalesApplicationService,
    ShareDataService,
    AppLoadService,
    GlobalEventService,
    GlobalErrorHandler,
    SharedService,
    ViewerService,
    ConfigService,
    RegisterCustomIconService,
    NavigationService,
    LocalResourcesManagerService,
    AgentInfoService,
    adpAPIService,
    UserService,
    DocumentLoaderService,
    TerashopService,
    SerializationHelperService,
    PipeLineErrorService,
    AppInsightsLoggingService,
    QuestionsService,
    MessageDisplayLoaderService,
    PreconnectService,
    SeoService,
    BrowserValidatorService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    UserPreferenceService
  ],
  
})
export class GspServicesModule {
  static forRoot(environment: any): ModuleWithProviders<GspServicesModule> {
    return {
      ngModule: GspServicesModule,
      providers: [
        {
          provide: ENV,
          useValue: environment,
        },
      ],
    };
  }
}
